<template>
	<div ref="trustedDeviceModalRef" class="modal fade" tabindex="-1" id="trustedDeviceModal" aria-labelledby="trustedDeviceModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered sheetModal popOutModal">
			<div class="modal-content rounded-sm">
				<div class="modal-body d-flex flex-column p-4 align-items-center">
					<h3 class="fw-semi-bold m-0">Trust this Device?</h3>
					<p class="text-secondary text-center mt-2">You have logged in with a new device which is not in the list of your Trusted Devices.</p>
					<div class="d-flex flex-column w-100 align-items-center justify-content-center">
						<div class="d-flex mt-4 gap-3">
							<button class="btn btn-outline-secondary rounded-pill py-6" @click="closeModal">Don't Trust this Device</button>
							<button class="btn btn-dark rounded-pill py-6" data-bs-dismiss="modal" @click="markTrustedDevice">Trust this Device</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Modal from "bootstrap/js/dist/modal";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";
import { useToast } from "@/composables/useToast.js";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import { useRouter } from "vue-router";

const emits = defineEmits(['closeModal']);

const props = defineProps({
	email: { type: String, required: false, default: null },
	user_id: { type: [String, Number], required: false, default: null }
});

const { displayToast } = useToast();
const helper = useAppHelpers();
const router = useRouter();

const trustedDeviceModal = ref(null);
const trustedDeviceModalRef = ref(null);

const closeModal = () => {
	trustedDeviceModal.value.hide();
	// helper.copyText(recoveryCodesString.value);
	// displayToast('Recovery codes copied to clipboard.', 'outline-success', 5000);
}

const markTrustedDevice = async () => {
	try{
		if(!props.user_id && !props.email){
			return;
		}

		helper.loaderOn(trustedDeviceModalRef.value);
		const response = await apiClient.post('/auth/markTrustedDevice', {
			'user_id': props.user_id,
			'email': props.email
		});

		if(response.status === 200){
			displayToast('This device is successfully marked as a trusted device.', 'outline-success', 10000);

		}
		if(response.status === 201){
			displayToast({heading: 'Robot Detected!', message: 'This device can\'t be marked as a trusted device.'}, 'outline-success', 10000);
		}
		helper.loaderOff(trustedDeviceModalRef.value);
		trustedDeviceModal.value.hide();
	}
	catch(error){
		let errorObj = await useHttpErrorManager().handleError(error);
		let message = errorObj['full_message'];
		displayToast(message, 'outline-danger', 8000);
		helper.loaderOff(trustedDeviceModalRef.value);
	}
}

onMounted(() => {
	let trustedDeviceModalEl = document.getElementById('trustedDeviceModal');
	trustedDeviceModal.value = Modal.getOrCreateInstance(trustedDeviceModalEl);

	trustedDeviceModalEl.addEventListener('hide.bs.modal', (event) => {
		emits('closeModal');
	});

	trustedDeviceModal.value.show();

});
</script>

<style scoped lang="scss">

</style>